import { render, staticRenderFns } from "./ShowClothesToRentalReportCompareAmounts.vue?vue&type=template&id=dc64e582&"
import script from "./ShowClothesToRentalReportCompareAmounts.vue?vue&type=script&lang=js&"
export * from "./ShowClothesToRentalReportCompareAmounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports